module.exports = __webpack_public_path__ + "static/img/hamilton3.155cebb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/hamilton3.jpg
// module id = 98
// module chunks = 9